import React, {
  useRef,
  useEffect,
  useState,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import SnTab from "@shared/components/SnTab";
import SnGrid from "@shared/components/GridV2/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType";

interface Props {
  Menuprops: menuInfo;
}

const SN_MTL_QIO_REP_001_TEX = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
    grid2: React.createRef<SnGridRef>(),
    grid3: React.createRef<SnGridRef>(),
  });

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };

  const searchRef = useRef<any>(null);

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
  });
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        // 초기값에 공유로 받은 값이 있으면 덮어쓰지 않고 유지
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
          grid4: rtn.grid.grid4,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    // 품목팝업 품목유형 원단
    searchRef.current?.applyPopupConditions?.({
      cd_item: { tp_item: "FAB" },
    });
  }, []);

  //#region onSearch
  const onSearch = async (searchData: any) => {
    try {
      const searchDataToUse = searchData || searchRef.current.getFormdata();
      const params = {
        id: "sn_mtl_qio_rep_001_tex_01",
        params: searchDataToUse,
      };

      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0] || [],
        grid2: data[1] || [],
        grid3: data[2] || [],
        grid4: data[3] || [],
      });
    } catch (error: any) {}
  };
  //#endregion

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
      },
      grid4: {
        columns: columns.grid4,
        dataSource: dataSources.grid4,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1">
        <SnTab
          titles={["입고", "작업중", "출고", "미출고"]}
          width={"100%"}
          body={[
            <div className="flex-1 h-full min-h-0 space-y-1.5">
              <SnGrid
                ref={gridRefs.current["grid1"]} // Grid Name
                columnConfig={grids.grid1.columns} // 컬럼 설정 전달
                rowData={grids.grid1.dataSource} // Datasource
                etcProps={{
                  rowSelection: "multiple",
                  isEditable: false,
                }}
              />
            </div>,
            <div className="flex-1 h-full min-h-0 space-y-1.5">
              <SnGrid
                ref={gridRefs.current["grid2"]} // Grid Name
                columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                rowData={grids.grid2.dataSource} // Datasource
                etcProps={{
                  rowSelection: "multiple",
                  isEditable: false,
                }}
              />
            </div>,
            <div className="flex-1 h-full min-h-0 space-y-1.5">
              <SnGrid
                ref={gridRefs.current["grid3"]} // Grid Name
                columnConfig={grids.grid3.columns} // 컬럼 설정 전달
                rowData={grids.grid3.dataSource} // Datasource
                etcProps={{
                  rowSelection: "multiple",
                  isEditable: false,
                }}
              />
            </div>,
            <div className="flex-1 h-full min-h-0 space-y-1.5">
              <SnGrid
                ref={gridRefs.current["grid4"]} // Grid Name
                columnConfig={grids.grid4.columns} // 컬럼 설정 전달
                rowData={grids.grid4.dataSource} // Datasource
                etcProps={{
                  rowSelection: "multiple",
                  isEditable: false,
                }}
              />
            </div>,
          ]}
        />
      </div>
    </div>
  );
});

export default SN_MTL_QIO_REP_001_TEX;
